// @flow

import { gql } from "@apollo/client";

export default {
  proof: gql`
    fragment CustomizationAreaArtworkListItem_proof on Proof {
      asset {
        url {
          formatted
        }
      }
      originalFilename
    }
  `
};
